import React, { useEffect, useState } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { callApi, validateToken } from "../../lib/utils";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import { styles } from "./style";
import { css } from "aphrodite";
import axios from "axios";
import CustomLoader from "../GenericComponents/CustomLoader";
import SideMenuComponentsHeader from "../GenericComponents/Headers/SideMenuComponentsHeader";
import Footer from "../GenericComponents/Footer";
import { Button, Modal, Spinner } from "react-bootstrap";
import "./PaymentTransactions.css";

const PaymentTransactions = () => {
    const history = useHistory();
    const [transactionsList, setTransactionsList] = useState([]);
    const [invoiceData, setInvoiceData] = useState({});
    let [isloading, setLoading] = useState(false);
    const patientSubscription = useSelector((state) => state?.appstate?.patientSubscription);

    useEffect(() => {
        let params = {
            start: null,
            end: null,
            timezone: moment.tz.guess(),
            page: 1,
            limit: 20
        }
        setLoading(true);
        try {
            validateToken((err) => {
                if (err) {
                    // console.log(err);
                    window.location = "/logout";
                }
                callApi(`/api/orders/payment-transactions/list`, params, "POST")
                    .then((response) => {
                        if (response.data.data.paymentTransactions.length !== 0) {
                            setTransactionsList(response.data.data.paymentTransactions);
                            setInvoiceData(response.data.data.paymentTransactions[0]);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        setLoading(false);
                    });
            });
        } catch (e) {
            console.log("Error", e);
        }
    }, []);

    const pdfExport = (data) => {
        let params = {
            //start: startDate,
            //end: endDate,
            stripeInvoiceId: data.invoiceId,
            timezone: moment.tz.guess(),
        };
        setLoading(true);

        axios({
            method: "post",
            url: `/api/orders/payment-transaction/invoice/export`,
            responseType: "blob",
            data: params,
        })
            .then((response) => {
                var filename = "";
                let disposition = null;

                if (Object.keys(response.headers).includes("content-disposition")) {
                    disposition = response.headers["content-disposition"];
                } else if (
                    Object.keys(response.headers).includes("Content-Disposition")
                ) {
                    disposition = response.headers["Content-Disposition"];
                }

                // var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                let blobData = response.data;
                setLoading(false);
                fileDownload(filename, blobData, "pdf");
            })
            .catch((err) => {
                console.log("err: ", err);
                setLoading(false);
            });
    };

    const fileDownload = (filename, blobData, type) => {
        var blobURL = window.URL.createObjectURL(blobData);
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute(
            "download",
            filename !== ""
                ? `${filename}`
                : type === "xlsx"
                    ? "report.xlsx"
                    : type === "csv" ? "report.csv" : "report.pdf"
        );
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    };

    const showInvoice = (row) => {
        setInvoiceData(row);
    }

    return (
        <div className="account-page">
            <CustomLoader loading={isloading} />
            {/* <SideMenuComponentsHeader title={"Payment Transactions"} /> */}
            <div className={css(styles.mainGrid)}>
                <div className={css(styles.header)}>{"Payment Transactions"}</div>
                {Object.keys(invoiceData).length !== 0 &&
                    <div className="">
                        {invoiceData.invoiceId !== null &&
                            <div className="page-header text-blue-d2">
                                <div className="page-tools">
                                    <div className="action-buttons">
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => pdfExport(invoiceData)}
                                            className="button"
                                            style={{ padding: "0px 5px" }}
                                            title="click to download invoice"
                                        >
                                            <i className="mr-1 fa fa-file-pdf-o text-danger-m1 text-120 w-2"></i>
                                            {" Download PDF"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="px-0">
                            <div className="row mt-3">
                                <div className="col-12 col-lg-12">
                                    <div className="row" >
                                        <div className="text-95 col-sm-4">
                                            <div className="text-grey-m2">
                                                <div className="mt-1 mb-2 text-400 text-125" style={{ fontSize: "22px", color: "black" }}>
                                                    Recent Invoice
                                                </div>
                                                <div>
                                                    <div className="my-2"><i className="fa fa-circle text-blue-m2 text-xs mr-1"></i> <span className="text-600 text-90">Transaction ID : </span>{invoiceData.transactionId}</div>
                                                    <div className="" style={{ marginTop: "0.5rem", marginBottom: "2em" }}><i className="fa fa-circle text-blue-m2 text-xs mr-1"></i> <span className="text-600 text-90">Amount : </span>${invoiceData.amount.amount_received}</div>


                                                    <div className=""><i className="fa fa-circle text-blue-m2 text-xs mr-1"></i> <span className="text-600 text-90">Payment Status : </span>{invoiceData.paid ? "Paid" : "Unpaid"}</div>

                                                    <div className="">
                                                        <span className="text-600 text-90">{`xxxx xxxx xxxx ${invoiceData.paymentMethod.card.last4}`} on {moment(invoiceData.paymentDate).format("MM/DD/YYYY")}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-95 col-sm-4">
                                            <div className="text-grey-m2">
                                                <div className="mt-1 mb-2 text-400 text-125" style={{ fontSize: "22px", color: "black" }}>
                                                    Subscription Status : <span className="text-600 text-90">{patientSubscription.status === 1 || patientSubscription.status === 5 ? "Active" : "Cancelled"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {isloading ?
                    <></>
                    : transactionsList.length !== 0 ?
                        <div className="table-responsive mt-5">
                            <table className="table table-hover">
                                <thead style={{ backgroundColor: "#216ba5" }}>
                                    <tr className="text-white">
                                        <th className="opacity-2">#</th>
                                        <th>Transaction ID</th>
                                        {/* <th>Status</th> */}
                                        <th>Paid On</th>
                                        <th>CC Number</th>
                                        <th width="140">Amount</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody className="text-95 text-secondary-d3">
                                    {transactionsList.map((val, index) => {
                                        return (
                                            <tr style={{ verticalAlign: "middle" }} onClick={() => showInvoice(val)}>
                                                <td>{index + 1}</td>
                                                <td>{val.transactionId}</td>
                                                {/* <td style={{ textTransform: "uppercase" }}>{val.status}</td> */}
                                                <td>{moment(val.paymentDate).format("MM/DD/YYYY")}</td>
                                                <td>{`xxxx xxxx xxxx ${val.paymentMethod.card.last4}`}</td>
                                                <td>{val.currency === "usd" ? `$${val.amount.amount_received}` : `$${val.amount.amount_received}`}</td>
                                                <td>
                                                    {val.invoiceId !== null &&
                                                        <Button
                                                            variant="link"
                                                            onClick={() => pdfExport(val)}
                                                            className={css(styles.buttonStyle)}
                                                            style={{ padding: "0px 5px" }}
                                                            title="click to download invoice"
                                                        >
                                                            <img
                                                                src="/images/pdf-export2.png"
                                                                alt="pdf export"
                                                                className={css(styles.imageiconsMenu)}
                                                            />
                                                        </Button>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ padding: "1em 0em" }}>
                            <h5 style={{ boxShadow: "0px 3px 0px 0px" }} class="alert alert-info">There are no payment transactions to display.</h5>
                        </div>
                }
            </div>
            <Footer />
        </div>
    );
};

export default withRouter(PaymentTransactions);
